module.exports = "/assets/data/67b1de592603106394ea7284869ed6ca-GU2.data.json";